module.exports = __webpack_public_path__ + "resources/img/solution_finance_rescue_m_v2.05d30e3af4e86bdc64a16c3cee3a09cc.png";